export const PERMISSION_LEVELS = [
  { id: 0, label: "No Access", flow: "grey" },
  { id: 1, label: "View Only", flow: "yellow" },
  { id: 2, label: "Edit", flow: "blue" },
  { id: 3, label: "Create & Edit", flow: "green" },
  { id: 4, label: "Full Access", flow: "main" },
];

export const PERMISSION_LEVEL_KEYS = {
  NO_ACCESS: 0,
  VIEW_ONLY: 1,
  EDIT: 2,
  CREATE: 3,
  DELETE: 4,
};

export const PERMISSION_GROUPS = [
  {
    id: 0,
    label: "Customers",
  },
  {
    id: 1,
    label: "Orders",
  },
  {
    id: 2,
    label: "Parts",
  },
  {
    id: 3,
    label: "Work Orders",
  },
  {
    id: 4,
    label: "Labor",
  },
  {
    id: 5,
    label: "Shipping",
  },
  {
    id: 6,
    label: "Reporting",
  },
  {
    id: 7,
    label: "System Settings",
  },
  {
    id: 8,
    label: "UI",
  },
  {
    id: 9,
    label: "SALES",
  },
];

export const PERMISSION_GROUP_TYPES = {
  CUSTOMERS: 0,
  ORDERS: 1,
  PARTS: 2,
  WORK_ORDERS: 3,
  LABOR: 4,
  SHIPPING: 5,
  REPORTING: 6,
  SYSTEM: 7,
  UI: 8,
  SALES: 9,
};

export const PERMISSION_TYPES = {
  ACCESS: 0,
  BOOLEAN: 1,
};

export const PERMISSIONS = [
  {
    id: 1,
    label: "CUSTOMERS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.CUSTOMERS,
  },
  {
    id: 2,
    label: "CONTACTS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.CUSTOMERS,
  },
  {
    id: 3,
    label: "BARCODES",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.SYSTEM,
  },
  {
    id: 4,
    label: "BOXES",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.SHIPPING,
  },
  {
    id: 5,
    label: "DIPS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.PARTS,
  },
  {
    id: 6,
    label: "DISPLAYS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.REPORTING,
  },
  {
    id: 7,
    label: "ADMIN_LABOR",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.LABOR,
  },
  {
    id: 8,
    label: "LINE_ITEMS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.ORDERS,
  },
  {
    id: 9,
    label: "MATERIALS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.SYSTEM,
  },
  {
    id: 10,
    label: "ORDERS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.ORDERS,
  },
  {
    id: 11,
    label: "PARTS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.PARTS,
  },
  {
    id: 12,
    label: "SCHEDULE",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.WORK_ORDERS,
  },
  {
    id: 13,
    label: "SEARCH",
    type: PERMISSION_TYPES.BOOLEAN,
    group: PERMISSION_GROUP_TYPES.SYSTEM,
  },
  {
    id: 14,
    label: "SHIPMENTS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.SHIPPING,
  },
  {
    id: 15,
    label: "STATIONS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.SYSTEM,
  },
  {
    id: 16,
    label: "VENDORS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.SYSTEM,
  },
  {
    id: 17,
    label: "WORK_ORDERS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.WORK_ORDERS,
  },
  {
    id: 18,
    label: "TICKETS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.LABOR,
  },
  {
    id: 19,
    label: "ADDRESSES",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.CUSTOMERS,
  },
  {
    id: 20,
    label: "MERGE_CUSTOMERS",
    type: PERMISSION_TYPES.BOOLEAN,
    group: PERMISSION_GROUP_TYPES.CUSTOMERS,
  },
  {
    id: 21,
    label: "MERGE_PARTS",
    type: PERMISSION_TYPES.BOOLEAN,
    group: PERMISSION_GROUP_TYPES.PARTS,
  },
  {
    id: 22,
    label: "PERMISSIONS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.SYSTEM,
  },
  {
    id: 23,
    label: "ORGANIZATION_SETTINGS",
    type: PERMISSION_TYPES.BOOLEAN,
    group: PERMISSION_GROUP_TYPES.SYSTEM,
  },
  {
    id: 24,
    label: "USERS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.SYSTEM,
  },
  {
    id: 25,
    label: "MODELS",
    type: PERMISSION_TYPES.BOOLEAN,
    group: PERMISSION_GROUP_TYPES.UI,
  },
  {
    id: 26,
    label: "OUTBOUND",
    type: PERMISSION_TYPES.BOOLEAN,
    group: PERMISSION_GROUP_TYPES.UI,
  },
  {
    id: 27,
    label: "SUB_ROUTES",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.WORK_ORDERS,
  },
  {
    id: 28,
    label: "FILES",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.SYSTEM,
  },
  {
    id: 29,
    label: "REPORTS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.REPORTING,
  },
  {
    id: 30,
    label: "CALENDAR",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.SYSTEM,
  },
  {
    id: 31,
    label: "SALES",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.SALES,
  },
  {
    id: 32,
    label: "FINANCIALS",
    type: PERMISSION_TYPES.ACCESS,
    group: PERMISSION_GROUP_TYPES.SYSTEM,
  },
];

export const PERMISSIONS_KEY = {
  CUSTOMERS: 1,
  CONTACTS: 2,
  BARCODES: 3,
  BOXES: 4,
  DIPS: 5,
  DISPLAYS: 6,
  ADMIN_LABOR: 7,
  LINE_ITEMS: 8,
  MATERIALS: 9,
  ORDERS: 10,
  PARTS: 11,
  SCHEDULE: 12,
  SEARCH: 13,
  SHIPMENTS: 14,
  STATIONS: 15,
  VENDORS: 16,
  WORK_ORDERS: 17,
  TICKETS: 18,
  ADDRESSES: 19,
  MERGE_CUSTOMERS: 20,
  MERGE_PARTS: 21,
  PERMISSIONS: 22,
  ORGANIZATION_SETTINGS: 23,
  USERS: 24,
  MODELS: 25,
  OUTBOUND: 26,
  SUB_ROUTES: 27,
  FILES: 28,
  REPORTS: 29,
  CALENDAR: 30,
  SALES: 31,
  FINANCIALS: 32,
};
